// extracted by mini-css-extract-plugin
export default {"buttonLeft":"MenuleftButton_buttonLeft__ToDIM","selected":"MenuleftButton_selected__v1Iyi"};